export default [
  {
    path: '/',
    name: 'app-deashboard',
    component: () => import('@/views/DeashboardAdmin.vue'),
  },
]
